<script setup lang="ts">
import { Ref, ref } from "vue";

const loading: Ref<boolean> = ref(false);

type IProps = {
  click(): Promise<void>;
};
const props = defineProps<IProps>();

const click = async () => {
  loading.value = true;
  await props.click();
  loading.value = false;
};
</script>

<template>
  <button
    class="submit-button w-full"
    type="button"
    :disabled="loading"
    :loading="loading"
    @click="click"
  >
    <slot />
  </button>
</template>

<style scoped lang="scss">
.submit-button {
  height: 54px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 8px 24px;
  background-color: var(--m-primary-base);
  color: white;
  font-size: 18px;
  font-weight: 500;
  line-height: 38px;
}

.submit-button[disabled] {
  background-color: var(--gray-800);
  @apply disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none;
}
</style>
